import React from 'react';

function ActionButton(props) {
    const commonClass = props.disabled ? "action-button action-button-disabled" : "action-button action-button-enabled";
    const extraClasses = props.classes ? props.classes : "";

    return (
        <button onClick={props.onClick}
                disabled={!!props.disabled} className={`${commonClass} ${extraClasses}`}>
            {props.buttonText}
        </button>
    );
}


export default ActionButton;